import { useCallerAsset } from '../../features/profile/useCallerAsset'
import { useCurrentUser } from '../../hooks/useCurrentUser'
import { useI18n } from '../../i18n'
import { sampleApplicationStatusFor } from './sampleApplicationStatus'
import type { ApplicationStatusCardProps } from './ApplicationStatusCard'

/** "$5,000.00" from 5000, or undefined when the amount isn't loaded yet. */
function formatUsd(amount: number | null | undefined): string | undefined {
  if (amount == null) return undefined
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  })
}

/**
 * Card props for the current user's application status: the step choreography
 * still comes from the samples, while the per-user values — assetId and the
 * loan amount — come live from /me/asset-data. Both show an em dash until the
 * profile query resolves (usually instant, via the localStorage mirror).
 *
 * The action label is step-dependent (the KYC step says "Continue", not "View
 * Details"), so it's translated here from the sample's `actionLabelKey`.
 */
export function useApplicationStatusCard(): Omit<
  ApplicationStatusCardProps,
  'onAction'
> {
  const { status } = useCurrentUser()
  const { asset, assetId } = useCallerAsset()
  const { t } = useI18n()

  const { actionLabelKey, ...sample } = sampleApplicationStatusFor(status)

  return {
    ...sample,
    actionLabel: t(actionLabelKey),
    assetId: assetId ?? '—',
    cost: formatUsd(asset?.usdloanamount) ?? '—',
  }
}
